module.exports = __webpack_public_path__ + "static/media/user.cac3c471.jpg";